exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-bd8119c2]{font-size:1.75rem;font-weight:600;color:#2f2f2f}@media (max-width:768px){h2[data-v-bd8119c2]{font-size:1.75rem}}", ""]);

// exports
